import Container from '@/components/base/Container';
import ClosingLink from '@/components/base/ClosingLink';

export default function CommunitiesClosing() {
  return (
    <section aria-labelledby="communities-closing" className="bg-white pb-12 pt-16 md:pb-16 md:pt-20">
      <Container>
        <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-10 border-t border-[#E6E6E6] pt-12 md:pt-16 lg:grid-cols-12 lg:gap-x-14">
          <div className="lg:col-span-5">
            <p className="text-[12px] font-medium uppercase tracking-[0.12em] text-[#7A7A7A]">COMMON / COMMUNITIES</p>
            <h2 id="communities-closing" className="mt-5 font-heading text-[30px] font-semibold leading-[1.15] tracking-[-0.01em] text-[#222222] md:text-[36px] lg:text-[42px]">
              Every community has its own character.
            </h2>
            <p className="mt-5 max-w-[420px] text-[16px] leading-[1.6] text-[#5F5F5F]">
              We shape our management approach around the people, spaces, and priorities of each community.
            </p>
            <div className="mt-8">
              <ClosingLink to="/contact?type=partnership" label="Request a Proposal" />
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="aspect-[4/3] w-full overflow-hidden rounded-lg bg-[#F2F2F0] lg:aspect-auto lg:h-[420px]">
              <img
                src="https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_communities-closing.webp"
                alt="Contemporary beige residential community under a pale blue sky"
                title="Residential community managed by COMMON Property Management"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}